module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M5.342 14.17a10.726 10.726 0 0 1 8.828-8.828V1.856A14.144 14.144 0 0 0 1.856 14.17h3.486zM17.654 1.856v3.486c5.094.84 9.004 5.242 9.004 10.57 0 5.926-4.82 10.746-10.746 10.746-5.328 0-9.732-3.91-10.57-9.004H1.856c.868 7.028 6.794 12.488 14.056 12.488 7.86 0 14.232-6.372 14.232-14.232 0-7.262-5.46-13.186-12.49-14.054z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/nutritive-secondary.js
// module id = 1314
// module chunks = 14